// extracted by mini-css-extract-plugin
export var clickable = "Card-module--clickable--Krvw3";
export var container = "Card-module--container--vitqu";
export var containerOverlay = "Card-module--container-overlay--kLkiz";
export var expand = "Card-module--expand--VI-23";
export var intro = "Card-module--intro--+COqH";
export var pageContent = "Card-module--page-content--kD8E6";
export var sectionSpacingB = "Card-module--section-spacing-b--d0ZiC";
export var sectionSpacingT = "Card-module--section-spacing-t--M-J4u";